import { Component, OnDestroy } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from 'src/app/services/auth.service';
import { CoreService } from '../../../services/core.service';

@Component({
  selector: 'app-idle-timeout-dialog',
  standalone: true,
  templateUrl: './idle-timeout-dialogue.component.html',
  imports: [MatDialogContent, MatButton, MatIconModule, MatDialogClose],
})
export class IdleTimeoutDialogComponent implements OnDestroy {
  countdown = 60;
  private interval!: any;
  logoffNowClicked = false;

  constructor(
    private dialogRef: MatDialogRef<IdleTimeoutDialogComponent>,
    private authService: AuthService,
    private _coreService: CoreService,
  ) {
    this.startCountdown();
  }

  startCountdown() {
    this.interval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.logout();
      }
    }, 1000);
  }

  async stayLoggedIn() {
    this.clearCountdown();
    // Check if session is still valid before closing dialog
    const isValid = await this.authService.isSessionValid();
    if (isValid) {
      this.dialogRef.close(true);
    } else {
      this.dialogRef.close(false);
      this.authService.signOutUser().then(() => {
        this._coreService.onSuccessToaster(
          'Session Expired',
          'Your session expired in another tab. Please log in again.',
          true,
        );
      });
    }
  }

  logout() {
    this.clearCountdown();
    this.dialogRef.close(false);
    this.authService.signOutUser().then((r) => {
      if (!this.logoffNowClicked) {
        this._coreService.onSuccessToaster(
          'Session Timed Out',
          'You’ve been logged out due to inactivity. Please log in again to continue.',
          true,
        );
      }
    });
  }

  onLogout() {
    this.logoffNowClicked = true;
    this.logout();
  }

  clearCountdown() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = undefined;
    }
  }

  ngOnDestroy() {
    this.clearCountdown();
  }
}
